var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({ref:"slider_btn",class:[
    _vm.$style.navigationBtn,
    _vm.$style.nextBtn,
    _vm.$style[_vm.position]
  ],attrs:{"small":"","fab":"","depressed":"","color":"rgba(212, 32, 50, .25)"}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"color":"#fff"}},[_vm._v(" "+_vm._s(`mdi-chevron-${_vm.position}`)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }